import { Alert, AlertDescription, AlertTitle } from '@portals-platform/ui';
import { AlertCircle } from 'lucide-react';

interface ServerErrorAlertProps {
  title: string;
  error: { message?: string | undefined } | undefined;
}

export function ServerErrorAlert({ title, error }: ServerErrorAlertProps) {
  if (!error) {
    return null;
  }

  return (
    <Alert variant="destructive">
      <AlertCircle aria-hidden="true" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{error.message}</AlertDescription>
    </Alert>
  );
}
